import { render, staticRenderFns } from "./FileSystemSidebar.vue?vue&type=template&id=56da1ef6&scoped=true"
import script from "../services/FileSystemSidebar.js?vue&type=script&lang=js&external"
export * from "../services/FileSystemSidebar.js?vue&type=script&lang=js&external"
import style0 from "./FileSystemSidebar.vue?vue&type=style&index=0&id=56da1ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da1ef6",
  null
  
)

export default component.exports